import React from 'react';
import { remCss, scssVariables as variables } from 'src/helpers';

const PsychologyIcon = React.memo(({ width = 81, height = 80, viewBox = '0 0 81 80' }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={remCss(width)}
    height={remCss(height)}
    viewBox={viewBox}
  >
    <path
      fill={variables['colors-mc-primary']}
      fillOpacity='0.1'
      stroke={variables['colors-mc-primary']}
      d='M79.7856 40C79.7856 61.8153 62.1009 79.5 40.2856 79.5C18.4704 79.5 0.785645 61.8153 0.785645 40C0.785645 18.1848 18.4704 0.5 40.2856 0.5C62.1009 0.5 79.7856 18.1848 79.7856 40Z'
    />
    <g clipPath='url(#clip0_414_13857)'>
      <path
        d='M36.722 15C32.7857 15 29.5947 18.191 29.5947 22.1272V31.4691L34.1847 29.2545H40.2856L41.1852 22.7356L40.2856 15L36.722 15Z'
        fill='#424B7F'
      />
      <path
        d='M43.8493 15H40.2856V29.2545H43.8492C47.7854 29.2545 50.9765 26.0636 50.9765 22.1272C50.9765 18.191 47.7855 15 43.8493 15Z'
        fill='#283366'
      />
      <path
        d='M38.5308 42.991L35.1235 51.2417L43.8655 51.3183L40.2857 42.991H38.5308Z'
        fill='#6666FF'
      />
      <path
        d='M59.7684 41.248C58.5522 40.0319 56.5806 40.0319 55.3645 41.248L53.6215 42.9911H40.2856V51.3184L53.9 51.5203L59.7685 45.6518C60.9845 44.4358 60.9845 42.4641 59.7684 41.248Z'
        fill='#5634FF'
      />
      <path d='M27.8159 56.3345H32.1132V63.5353H27.8159V56.3345Z' fill='#424B7F' />
      <path d='M55.0557 56.3345H59.3529V63.5353H55.0557V56.3345Z' fill='#283366' />
      <path
        d='M21.9543 34.5894C20.4006 36.1431 20.4006 38.6622 21.9543 40.2159L23.0308 41.2923C24.5845 42.846 27.1036 42.846 28.6573 41.2923C30.211 39.7386 30.211 37.2195 28.6573 35.6657L27.5808 34.5893C26.0272 33.0357 23.5082 33.0357 21.9543 34.5894Z'
        fill='#FFE5CF'
      />
      <path d='M35.8911 20.8594H38.8208V23.7891H35.8911V20.8594Z' fill='#FFF5F5' />
      <path d='M41.7505 20.8594H44.6802V23.7891H41.7505V20.8594Z' fill='#ECE6F2' />
      <path
        d='M15.2856 62.0703V65H40.2856L41.4197 63.5352L40.2856 62.0703H15.2856Z'
        fill='#ECE6F2'
      />
      <path d='M40.2856 62.0703H65.2856V65H40.2856V62.0703Z' fill='#CECDE4' />
      <path
        d='M36.0115 41.2644L33.8043 43.4716L32.4819 42.1492C31.0732 40.7404 28.7893 40.7404 27.3805 42.1492L25.5273 44.0023L33.7922 52.2913L40.2855 45.798L40.8064 43.4702L40.2855 41.1423C39.0628 40.0502 37.1853 40.0906 36.0115 41.2644Z'
        fill='#ECE6F2'
      />
      <path
        d='M40.4154 41.2644C40.3731 41.2221 40.3297 41.1816 40.2856 41.1423V45.7981L40.4154 45.6683C41.6315 44.4521 41.6315 42.4804 40.4154 41.2644Z'
        fill='#CECDE4'
      />
      <path
        d='M31.098 48.9425L22.0485 39.893C20.5014 38.3459 17.993 38.3459 16.4459 39.893C14.8989 41.44 14.8989 43.9484 16.4459 45.4955L27.8162 56.8656H40.2857L43.8655 52.9041L40.2857 48.9425H31.098Z'
        fill='#FFBC37'
      />
      <path
        d='M61.3241 48.9424H40.2856V56.8655H61.3241C63.512 56.8655 65.2856 55.0919 65.2856 52.904C65.2856 50.716 63.512 48.9424 61.3241 48.9424Z'
        fill='#FF9966'
      />
    </g>
    <defs>
      <clipPath id='clip0_414_13857'>
        <rect width='50' height='50' fill='white' transform='translate(15.2856 15)' />
      </clipPath>
    </defs>
  </svg>
));
PsychologyIcon.displayName = 'PsychologyIcon';

export default PsychologyIcon;
